'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';

interface ProductSkeletonContainerProps {
  columns?: number;
  cardsCount?: number;
  className?: {
    container?: string;
  };
}

export function ProductSkeletonContainer({
  columns = 3,
  cardsCount = 6,
  className,
}: ProductSkeletonContainerProps) {
  return (
    <div
      className={cn('custom-container', 'grid grid-cols-3 gap-x-6 gap-y-8', className?.container)}
    >
      {Array.from({ length: cardsCount }).map((_, index) => (
        <ProductSkeletonCard key={index} />
      ))}
    </div>
  );
}

export function ProductSkeletonCard() {
  return <div className={cn('animate-pulse', 'h-[509px] w-full rounded-[24px] bg-neutral-100')} />;
}
